import { defineStore } from "pinia";

export const useUrlPopupStore = defineStore({
  id: "urlPopup",
  state: () => ({
    listUrlPopup: [],
  }),
  actions: {
    initUrlPopup() {
      this.listUrlPopup = [location.href];
    },
    pushUrlPopup(url) {
      this.listUrlPopup.push(url);
    },
    popUrlPopup() {
      if (this.listUrlPopup.length > 1) {
        this.listUrlPopup.pop();
      }
    },
  },
  getters: {
    latestUrlPopup(state) {
      const list = state.listUrlPopup;
      return list.length ? list[list.length - 1] : undefined;
    },
  },
});
